import { createRequestFactory } from "@/lib/request-factory";
import {
  GetClientReferralCodeDocument,
  type GetClientReferralCodeQueryVariables,
  type GetClientReferralCodeQuery,
} from "@/__generated__/graphql";

export const useClientReferralCodeStore = createRequestFactory<
  GetClientReferralCodeQuery,
  string,
  GetClientReferralCodeQueryVariables
>({
  method: "query",
  graphqlDocument: GetClientReferralCodeDocument,
  transformFunction: (data) => {
    return data.clientReferralCode.code ?? "";
  },
});
